/** Métricas da CustomTabBar — alinhadas ao app mobile (barra inferior flutuante). */
export const TAB_BAR_CONTENT_HEIGHT = 64;
export const TAB_BAR_FLOAT_MARGIN_H = 16;
export const TAB_BAR_FLOAT_MARGIN_BOTTOM = 12;
export const TAB_BAR_FLOAT_RADIUS = 28;
export const TAB_BAR_COLLAPSED_WIDTH = 92;
export const TAB_BAR_BOTTOM_INSET_MIN = 8;
export const TAB_BAR_OVERLAY_GAP = 12;

export const TAB_BUTTON_SIZE = 46;
export const CENTER_BUTTON_SIZE = 60;
export const PROFILE_AVATAR_SIZE = 30;
export const COLLAPSE_TOGGLE_SIZE = 32;
export const SIDE_ICON_SIZE = 28;

export const LIGHT_TAB_COLORS = {
  primary: "#5F33E1",
  secondary: "#6E6A7C",
  white: "#FAFAFA",
  navbarBg: "#EEE9FF",
  profileRingBg: "#E8E0FF",
} as const;

export function getTabBarBottomInset(safeAreaBottom = 0): number {
  return Math.max(safeAreaBottom, TAB_BAR_BOTTOM_INSET_MIN);
}

/** Altura total reservada no fundo (barra + margem + safe area). */
export function getTabBarTotalHeight(safeAreaBottom = 0): number {
  return (
    TAB_BAR_CONTENT_HEIGHT +
    TAB_BAR_FLOAT_MARGIN_BOTTOM +
    getTabBarBottomInset(safeAreaBottom)
  );
}

/** Distância do fundo até conteúdo flutuante acima da tab bar. */
export function getTabBarOverlayClearance(
  safeAreaBottom = 0,
  gap: number = TAB_BAR_OVERLAY_GAP
): number {
  return getTabBarTotalHeight(safeAreaBottom) + gap;
}
